import {Link} from 'react-router-dom';
import './Back.css';

const Back = () => <Link className="back" to="/"/>

export default Back;
